import Header from './header'
import Content from './content'
import WordpressStyle from './wordpress-style'
import Styles from 'components/pages/root/styles'

export default function ArticleSlug({ initData }) {
  const { article, tags } = initData
  return (
    <div>
      <div className='container mb-12'>
        <div className='md:flex md:justify-center'>
          <div className='md:w-2/3'>
            <Header article={ article } />
            <Content article={ article } />
          </div>
        </div>
      </div>
      <Styles tags={ tags }/>

      <C.CommonIntro />

      <WordpressStyle />
    </div>
  )
}
